<template>
	<div>
		<span class="highlightButton" @click="loadHighlightModal">
			<i class="fa-2x fa-heart" v-bind:class="isActive ? 'fas' : 'far'"></i>
		</span>

		<div v-if="showModal">
			<teleport to="#highlight-modal">
				<transition name="modal">
					<div class="modal-mask modal">
						<div class="modal-wrapper">
							<div class="modal-dialog">
								<div class="modal-content" @click.stop>
									<div class="modal-header">
										<div class="col-lg-12 dynvibeTitleBox dynvibeTitleModal">
											<h5 class="modal-title">
												Highlights
												<button type="button" class="close" @click="closeModal">
													<span aria-hidden="true">
														<i class="icon-x"></i>
													</span>
												</button>
											</h5>
										</div>
									</div>
									<div class="modal-body" id="highlight-modal-body">
										<div class="dynvibeBox" style="min-height: 100px">
											<div class="col-lg-12 dynvibeTitleBox">
												<h2>Add new highlight</h2>
											</div>
											<div class="col-lg-12">
												<div class="dynvibeRow addFavorite">
													<div>
														<div class="col-xs-12">
															<div v-if="errorsAdd !== ''" class="row dynvibeModalRowForm">
																<div class="alert alert-danger">{{ errorsAdd }}</div>
															</div>
														</div>
														<div class="col-xs-9">
															<autocomplete
																ref="autocomplete"
																:suggestions="panelTitles"
																placeholder="Title to add"
																@change="changeAutomplete"
																@autocomplete="changeAutomplete"
															>
															</autocomplete>
														</div>
														<div class="col-xs-3">
															<button type="button" @click.stop="addTitle" class="btn dynvibeButton">
																Add
															</button>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div class="dynvibeBox" style="min-height: 100px">
											<div class="col-lg-12 dynvibeTitleBox">
												<h2>Added highlights</h2>
											</div>

											<div v-if="!highlights.titles || highlights.titles.length === 0" class="noData">
												<p>No Data to display</p>
											</div>

											<table v-else class="table table-striped">
												<thead>
													<tr>
														<th class="col-md-9">Title</th>
														<th class="col-md-3">Action</th>
													</tr>
												</thead>
												<tbody>
													<tr v-for="highlight in highlights.titles" v-bind:key="highlight">
														<td class="col-md-9">{{ highlight }}</td>
														<td class="col-md-3">
															<button
																type="button"
																class="btn dynvibeButtonRed"
																@click="removeTitle(highlight, $event)"
															>
																Remove
															</button>
														</td>
													</tr>
												</tbody>
											</table>

											<input type="hidden" id="favorite-id-post" value="2258422498698323276" />
										</div>

										<div class="dynvibeBox" style="min-height: 100px">
											<div class="col-lg-12 dynvibeTitleBox">
												<h2>Existing highlights in the panel</h2>
											</div>
											<div v-if="!panelTitles || panelTitles.length === 0" class="noData">
												<p>No Data to display</p>
											</div>
											<table v-else class="table table-striped">
												<thead>
													<tr>
														<th class="col-md-9">Title</th>
														<th class="col-md-3">Action</th>
													</tr>
												</thead>
												<tbody>
													<tr v-for="title in panelTitles" :key="title">
														<td class="col-md-9">{{ title }}</td>
														<td class="col-md-3" v-if="!highlights.titles">
															<button
																type="button"
																class="btn dynvibeButton dynvibeAddFavoriteButton"
																@click="addTitle(title)"
															>
																Add
															</button>
														</td>
														<td class="col-md-3" v-else-if="highlights.titles.indexOf(title) === -1">
															<button
																type="button"
																class="btn dynvibeButton dynvibeAddFavoriteButton"
																@click="addTitle(title)"
															>
																Add
															</button>
														</td>
														<td class="col-md-3" v-else>&nbsp;</td>
													</tr>
												</tbody>
											</table>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</transition>
			</teleport>
		</div>
	</div>
</template>

<script>
import autocomplete from "@/components/globalVue/Autocomplete.vue";
export default {
	name: "highlight",
	props: {
		idpost: {
			type: String,
			default: () => "",
		},
		propActive: {
			type: Boolean,
			default: () => false,
		},
	},
	data() {
		return {
			showModal: false,
			content: "",
			panel: "",
			panelTitles: {},
			highlights: {},
			titleToAdd: "",
			isActive: false,
			errorsAdd: "",
		};
	},
	watch: {
		propActive: function () {
			this.isActive = this.propActive;
		},
	},
	mounted() {
		this.isActive = this.propActive;
	},
	components: {
		autocomplete: autocomplete,
	},
	methods: {
		closeModal() {
			this.showModal = false;
			this.errorsAdd = "";
			this.titleToAdd = "";
		},
		loadHighlightModal() {
			this.errorsAdd = "";
			let params = new URLSearchParams();
			params.append("idPost", this.idpost);
			this.$axios.post(this.$backendUrl + "highlightModal", params).then((response) => {
				this.showModal = true;
				this.panelTitles = response.data.panelTitles;
				this.highlights = response.data.highlights;
				this.panel = response.data.panel;
				this.isActive = false;
				if (this.highlights.titles && this.highlights.titles.length > 0) {
					this.isActive = true;
				}

				/*Vue.nextTick(() => {
          $("#addFavoriteTitle").autocomplete({
            source: this.panelTitles,
            appendTo: "#highlight-modal-body"
          });
        });*/
			});
		},
		addTitle(value) {
			try {
				this.titleToAdd = value.trim();
			} catch (e) {
				this.titleToAdd = this.titleToAdd.trim();
			}

			this.errorsAdd = "";
			if (this.titleToAdd === "") {
				this.errorsAdd = "Title can't be empty";
				return;
			}

			let params = new URLSearchParams();
			params.append("idPost", this.idpost);
			params.append("title", this.titleToAdd);

			this.$axios.post(this.$backendUrl + "highlightAdd", params).then(() => {
				this.titleToAdd = "";
				// if (event) {
				//   event.target.blur();
				// }
				this.loadHighlightModal();
				this.$refs.autocomplete.cleanSelection();
			});
		},
		removeTitle(title, event) {
			let params = new URLSearchParams();
			params.append("idPost", this.idpost);
			params.append("title", title);

			this.$axios.post(this.$backendUrl + "highlightRemove", params).then(() => {
				if (event) {
					event.target.blur();
				}
				this.loadHighlightModal();
			});
		},
		changeAutomplete(value) {
			this.titleToAdd = value;
			this.errorsAdd = "";
		},
	},
};
</script>

<style scoped>
.close {
	outline: 0;
}

.dynvibeTitleModal {
	padding-bottom: 10px;
	margin-bottom: 0;
}

.dynvibeTitleBox {
	margin-bottom: 0;
}

.highlightButton {
	cursor: pointer;
}

.highlightButton:hover {
	cursor: grab;
}

.fas.fa-heart {
	color: #c30213;
}

.dynvibeInputText {
	color: #757575;
}
</style>
